import { ProductEntryVector } from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "../helpers/withDelete";
import { toArray } from "../vector";
import { productRepository } from "./productRepository";
import { ProductCategory } from "./types";

export function buildSearchResults(
  searchResults: ProductEntryVector,
  showDeleted: boolean,
) {
  const categories = productRepository.getCategories(showDeleted);
  return toArray(searchResults).map((searchResult) =>
    withDelete(searchResult, {
      articleNumber: searchResult.articleNumber,
      deleted: searchResult.deleted,
      id: searchResult.id,
      label: searchResult.name,
      url: getProductUrl(categories, searchResult.id, showDeleted),
    }),
  );
}

function getProductUrl(
  categories: ProductCategory[],
  id: string,
  showDeleted: boolean,
): string | undefined {
  const [first, ...rest] = id.split("/");

  for (const category of categories) {
    if (category.id.endsWith(first)) {
      return `/selections/direct/${[category.id, ...rest].join("/")}${showDeleted ? "?showDeleted" : ""}`;
    }

    const url = getProductUrl(category.subCategories ?? [], id, showDeleted);
    if (url) return url;
  }
}
